import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { Route, Routes, useLocation } from 'react-router-dom';
import HomePage from '../pages/home';
// import CareerPage from '../pages/career';
import ContactPage from '../pages/contact';
import AboutPage from '../pages/about';
import SoftwarePage from '../pages/software';
import ReferencesPage from '../pages/references';
import HardwarePage from '../pages/hardware';
import LibecmsPage from '../pages/libecms';
import PartnershipPage from '../pages/partnership';
// import BlogDetailPage from '../pages/blog/detail';
// import BlogPage from '../pages/blog';

const AnimatedRoutes = () => {
    const location = useLocation();

    return (
        <AnimatePresence>
            <Routes key={location.pathname} location={location}>
                <Route path='/' element={<HomePage />} />
                {/* <Route path='/career' element={<CareerPage />} /> */}
                {/* <Route path='/kariyer' element={<CareerPage />} /> */}
                <Route path='/contact' element={<ContactPage />} />
                {/* <Route path='/iletisim' element={<ContactPage />} /> */}
                <Route path='/about-us' element={<AboutPage />} />
                {/* <Route path='/hakkimizda' element={<AboutPage />} /> */}
                <Route path='/software' element={<SoftwarePage />} />
                {/* <Route path='/yazilim' element={<SoftwarePage />} /> */}
                <Route path='/references' element={<ReferencesPage />} />
                {/* <Route path='/referanslar' element={<ReferencesPage />} /> */}
                <Route path='/hardware' element={<HardwarePage />} />
                {/* <Route path='/donanim' element={<HardwarePage />} /> */}
                <Route path='/libecms' element={<LibecmsPage />} />
                <Route path='/partnership' element={<PartnershipPage />} />
                {/* <Route path='/ortaklik' element={<PartnershipPage />} /> */}
                {/* <Route path='/blog' element={<BlogPage />} />
                <Route path='/blog-detail' element={<BlogDetailPage />} /> */}
                {/* <Route path='/blog-detay' element={<BlogDetailPage />} /> */}
                <Route path='/*' element={<HomePage />} />
            </Routes>
        </AnimatePresence>
    );
};

export default AnimatedRoutes;
